import { IStateCustomer } from "@/apps/merchant3/models/IStateCustomer";
import ICustomer from "@/types/customer";
import { IOptionDropdown } from "@/types/dropdown";

const getters = {
  customer: (state: IStateCustomer): IStateCustomer => state,
  getSelectedState: (state: ICustomer): IOptionDropdown | null => {
    if (state?.state) {
      return {
        name: state.state,
        code: state.stateCode || "",
      } as IOptionDropdown;
    }
    return null;
  },
};

export default getters;
